import { notificationSystem } from '@/assets/notifications.json';

export default {
  data: () => ({
    notificationSystem,
  }),
  methods: {
    showErrors(error) {
      error.forEach((item) => {
        this.$toast.error(item.debugMessage, 'Erro!', this.notificationSystem.options.error);
      });
    },
  },
};
